import React from 'react'
import './about.css'
import {TbRocket} from 'react-icons/tb'
import {RiNumbersLine} from 'react-icons/ri'
import SLIDES from '../../assets/gx-gif1.gif'


const About = () => {
  return (
    <section id='about'>
      <h5>Introducing</h5>
      <h2>GX</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={SLIDES} alt="About" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <TbRocket className="about__icon" />
              <h5>What is GX?</h5>
              <small>GX is a term created to define budz that:<li></li> - have at least one gadget, and<li></li>- those gadgets exclude covered helmet, chestplate, and belt. </small>
            </article>
            <article className="about__card">
              <RiNumbersLine className="about__icon" />
              <h5>How many GX are there?</h5>
              <small>There are 96 GX, consisting of:<li></li>1GX : 47 [one gadget],<li>2GX : 43 [two gadgets],</li> <li>3GX : 5 [three gadgets],</li> <li>4GX : 1 [four gadgets].</li></small>
            </article>
          </div>
          <p></p>

          <a href="https://twitter.com/GXBudz" target='_blank' rel="noreferrer" className='btn btn-primary'>Click to visit GX Budz Twitter</a>
        </div>
      </div>
    </section>
  )
}

export default About